'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function HeroInfiniteCarousel() {
  const { t } = useTranslations();

  const data = [
    'Pánske oblečenie',
    'Dámske oblečenie',
    'Detské oblečenie',
    'Módne doplnky',
    'Športové oblečenie',
    'Elegantné oblečenie',
    t('text3470'),
  ];

  return (
    <div className="relative w-full overflow-hidden bg-black py-3 sm:py-4 lg:py-5">
      <div className="animate-infinite-scroll flex">
        <div className="flex shrink-0 items-center">
          {data.map((item, index) => (
            <div key={`first-${index}`} className="flex items-center">
              <p
                className={cn(
                  'whitespace-nowrap text-xl font-medium uppercase text-white sm:text-2xl lg:text-[28px]',
                  {
                    'text-primary': item === t('text3470'),
                  },
                )}
              >
                {item}
              </p>
              <Image
                src="/images/star.svg"
                alt={item}
                width={16}
                height={16}
                className="mx-3 h-auto min-w-4 max-w-4 object-contain"
              />
            </div>
          ))}
        </div>
        <div className="flex shrink-0 items-center" aria-hidden="true">
          {data.map((item, index) => (
            <div key={`second-${index}`} className="flex items-center">
              <p className="whitespace-nowrap text-xl font-medium uppercase text-white sm:text-2xl lg:text-[28px]">
                {item}
              </p>
              <Image
                src="/images/star.svg"
                alt=""
                width={16}
                height={16}
                className="mx-3 h-auto min-w-4 max-w-4 object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
